export default {
  setHotelSchema(configSettings) {
    return JSON.stringify({
      config: {
        country: configSettings.country,
        language: configSettings.language,
        action: 's',
        passenger: configSettings.passengers,
        pagination: {
          offset: 0,
          count: configSettings.count
        },
        sorting: [
          {
            type: 'price',
            order: 'asc'
          }
        ],
        attribution: {
          product: configSettings.product,
          subcategory: 'bananas',
          pagetype: 'conversion',
          pageid: configSettings.pageid.toString(),
          usersession: 'none'
        }
      },
      portions: [
        {
          origin: [
            {
              type: Object.keys(configSettings.destinationToSearch)[0],
              value:
                configSettings.destinationToSearch[
                  Object.keys(configSettings.destinationToSearch)[0]
                ][0]
            }
          ],
          dep: {
            start: configSettings.startDate
          },
          arr: {
            end: configSettings.endDate
          },
          destination: [
            {
              type: Object.keys(configSettings.destinationToSearch)[0],
              value:
                configSettings.destinationToSearch[
                  Object.keys(configSettings.destinationToSearch)[0]
                ][0]
            }
          ]
        }
      ],
      accommodation: {
        category: {
          min: configSettings.minHotelCategory
        },
        room: {
          count: configSettings.rooms
        },
        board: {
          min: configSettings.minBoardType
        },
        rating: {
          overall: {
            min: configSettings.minHotelRating
          }
        },
        refundable: configSettings.refundable
      }
    })
  }
}
